function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MenuTemplate = require('./menu.template');
var Menu = /*#__PURE__*/function () {
  function Menu(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var composer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, Menu);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.composer = composer;
    this.user = {
      name: 'Your Name',
      handle: 'you',
      avatar: '/saito/img/dreamscape.png'
    };
    this.notification_count = 0;
    this.has_chat = false;
  }
  return _createClass(Menu, [{
    key: "render",
    value: function render() {
      var _this$mod$getUnreadNo, _this$mod, _this$mod$main, _this$mod$main$hasCha, _this$mod$manager, _this$mod$manager$isP;
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.notification_count = ((_this$mod$getUnreadNo = (_this$mod = this.mod).getUnreadNotificationCount) === null || _this$mod$getUnreadNo === void 0 ? void 0 : _this$mod$getUnreadNo.call(_this$mod)) || 0;
      this.has_chat = ((_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 || (_this$mod$main$hasCha = _this$mod$main.hasChatCapability) === null || _this$mod$main$hasCha === void 0 ? void 0 : _this$mod$main$hasCha.call(_this$mod$main)) || false;
      this.app.browser.replaceElementContentBySelector(MenuTemplate(this), this.container);
      this.attachEvents();

      // Template defaults Home to .active; clear when user-content is the active view.
      if ((_this$mod$manager = this.mod.manager) !== null && _this$mod$manager !== void 0 && (_this$mod$manager$isP = _this$mod$manager.isProfileMode) !== null && _this$mod$manager$isP !== void 0 && _this$mod$manager$isP.call(_this$mod$manager)) {
        this.clearActiveMenuItem();
      }
    }
  }, {
    key: "updateBadge",
    value: function updateBadge() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.notification_count = count;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var icon = root.querySelector('[data-nav="notifications"] .icon');
      if (!icon) {
        return;
      }
      var badge = icon.querySelector('.badge');
      if (count > 0) {
        if (!badge) {
          this.app.browser.addElementToSelector("<span class=\"saito-notification-dot badge\" aria-hidden=\"true\">".concat(count, "</span>"), "".concat(this.container, " [data-nav=\"notifications\"] .icon"));
          return;
        }
        badge.textContent = String(count);
        return;
      }
      if (badge) {
        badge.remove();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var root = document.querySelector(this.container);
      if (!root || root.dataset.menuBound) {
        return;
      }
      root.dataset.menuBound = '1';

      // The container survives menu renders; delegate to its current buttons.
      root.addEventListener('click', function (event) {
        var _this$mod$main2, _this$mod$manager2, _this$mod$main3, _this$mod$manager3, _this$mod$main4, _this$mod$main5;
        var item = event.target.closest('.menu .item[data-nav]');
        if (!item || !root.contains(item)) {
          return;
        }
        switch (item.dataset.nav) {
          case 'home':
            (_this$mod$main2 = _this.mod.main) === null || _this$mod$main2 === void 0 || _this$mod$main2.showMobileView('feed');
            (_this$mod$manager2 = _this.mod.manager) === null || _this$mod$manager2 === void 0 || _this$mod$manager2.renderHome();
            _this.setActiveMenuItem(item);
            break;
          case 'notifications':
            (_this$mod$main3 = _this.mod.main) === null || _this$mod$main3 === void 0 || _this$mod$main3.showMobileView('feed');
            (_this$mod$manager3 = _this.mod.manager) === null || _this$mod$manager3 === void 0 || _this$mod$manager3.renderNotifications();
            _this.setActiveMenuItem(item);
            break;
          case 'chat':
            if ((_this$mod$main4 = _this.mod.main) !== null && _this$mod$main4 !== void 0 && _this$mod$main4.showMobileView('chat')) {
              _this.setActiveMenuItem(item);
            }
            break;
          case 'settings':
            if ((_this$mod$main5 = _this.mod.main) !== null && _this$mod$main5 !== void 0 && _this$mod$main5.showMobileView('settings')) {
              _this.setActiveMenuItem(item);
            } else {
              var _this$mod$settings_ov;
              (_this$mod$settings_ov = _this.mod.settings_overlay) === null || _this$mod$settings_ov === void 0 || _this$mod$settings_ov.open();
            }
            break;
        }
      });
    }
  }, {
    key: "setActiveMenuItem",
    value: function setActiveMenuItem(activeItem) {
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }

      // Scope to primary nav items only (avoid chat-list .item nodes in .sidebar-left).
      root.querySelectorAll('.menu .item[data-nav]').forEach(function (item) {
        item.classList.toggle('active', Boolean(activeItem) && item === activeItem);
      });
    }

    /**
     * Clear primary-nav selection. Used for user-content views (posts/replies/likes),
     * which are not primary destinations like Home or Notifications.
     */
  }, {
    key: "clearActiveMenuItem",
    value: function clearActiveMenuItem() {
      this.setActiveMenuItem(null);
    }
  }]);
}();
module.exports = Menu;